import { Notyf } from 'notyf';
import 'notyf/notyf.min.css';
// import '../styles/notify-single-word.css';

const notyf = new Notyf({
    duration: 2000,
}); // Создание экземпляра

export function showSuccess(message) {
    notyf.dismissAll();
    notyf.success(message); // Функция для успешного уведомления
}

export function showError(message) {
    notyf.dismissAll();
    notyf.error(message); // Функция для уведомления об ошибке
}